import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Key, Calendar, HardDrive, Server } from "lucide-react";

export function ActiveLicenseInfoSkeleton() {
    return (
        <div className="oct_license-card-v2 w-100 mb-0">
            {/* License Header Skeleton */}
            <div className="oct_license-header-v2">
                <h3>
                    <Key className="oct_icon text-muted" />
                    <Skeleton variant="text" width={150} height={32} />
                </h3>
                <div className="oct_license-meta">
                    <Skeleton variant="text" width={200} height={20} className="mb-1" />
                    <Skeleton variant="text" width={160} height={20} />
                </div>
            </div>

            {/* License Details Grid Skeleton */}
            <div className="oct_license-grid-v2">
                {/* End Date Skeleton */}
                <div className="oct_license-stat-card-v2">
                    <div className="oct_icon-wrapper bg-light">
                        <Calendar className="oct_icon text-muted" />
                    </div>
                    <div className="oct_stat-content w-100">
                        <Skeleton variant="text" width="40%" height={16} className="mb-1" />
                        <Skeleton variant="text" width="80%" height={28} />
                    </div>
                </div>

                {/* Max Devices Skeleton */}
                <div className="oct_license-stat-card-v2">
                    <div className="oct_icon-wrapper bg-light">
                        <HardDrive className="oct_icon text-muted" />
                    </div>
                    <div className="oct_stat-content w-100">
                        <Skeleton variant="text" width="50%" height={16} className="mb-1" />
                        <Skeleton variant="text" width="60%" height={28} />
                    </div>
                </div>
            </div>

            {/* License Key Section Skeleton */}
            <div className="oct_license-key-section-v2">
                <label>
                    <Server className="oct_icon text-muted" />
                    <Skeleton variant="text" width={100} height={24} />
                </label>
                <div className="oct_key-input-row flex-column flex-sm-row">
                    <Skeleton variant="rectangular" className="w-100 rounded" height={86} />
                    <Skeleton variant="rectangular" width={110} height={42} className="rounded oct_license-submit-btn-v2" />
                </div>
            </div>
        </div>
    );
}

export default ActiveLicenseInfoSkeleton;
